var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamicFeedB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H3V7.5C3 8.05 3.45 8.5 4 8.5H8.5V7.5H4V4Z",
    fill: "#1C1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5H6C5.45 1.5 5 1.95 5 2.5V5.5C5 6.05 5.45 6.5 6 6.5H10C10.55 6.5 11 6.05 11 5.5V2.5C11 1.95 10.55 1.5 10 1.5ZM10 5.5H6V3.5H10V5.5Z",
    fill: "#1C1C1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H1V9.5C1 10.05 1.45 10.5 2 10.5H6.5V9.5H2V6Z",
    fill: "#1C1C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicFeedB);
export default __webpack_public_path__ + "static/media/dynamic-feed_b.9332cbddc26b35c0bd3c9cd1942bbed3.svg";
export { ForwardRef as ReactComponent };